import fetch from 'isomorphic-fetch';

let ENDPOINT_URL = process.env.VUE_APP_AGREGAR_PERSONAL;
async function addPersonnel(date, ruta, item, responsable) {
  const bodyParams = {
    fecha_programacion: date,
    codigo_ruta: ruta,
    token: localStorage.getItem('token'),
    _id: item._id,
    doi: item.doi.toString(),
    nombre: item.nombre,
    cargo: item.datos_laborales.cargo,
    responsable,
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { addPersonnel };
